module.exports = __webpack_public_path__ + "static/media/pigeage-barrel.87387744.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/pigeage-barrel.mp4
 ** module id = 467
 ** module chunks = 0
 **/